import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { getMuiTheme } from "./styles";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pathOr } from "ramda";
import { removeDashlet, configureDashlet, getCurrentTab } from "../../../../store/actions/dashboard.actions";

import { DashletList, EditDashlet } from "../../components";
import { Link,Grid, Card,CardMedia,Typography, IconButton, CardHeader, Menu, MenuItem, CardContent, CardActions, Button, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, useTheme } from "@material-ui/core";

import "./style.css";
import Iframe from 'react-iframe';

// import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import { MoreVert } from "@material-ui/icons";
//import { AORCharts } from '../../../../components';
import { toast } from "react-toastify";


import CircularProgress from '@material-ui/core/CircularProgress';
// import dashboardImg from '../../../../assets/dashboard-report.png';
// import { Scrollbars } from 'react-custom-scrollbars';
import { NoRecord, FaIcon, AORCharts } from "../../../../components";
import { CustomCardList, CustomDashletList, CustomDashletChart, CustomDashletFilter, CustomDashletCompare, CustomTableList, ProgressBar,CustomDashletForm } from "./components/";
import CustomDashletChartXirr  from "./components/CustomDashletChart/CustomDashletChartXirr";
import CustomDashletGroupChartXirr  from "./components/CustomDashletChart/customDashletGroupChartXirr";
import CustomDashletMixChart from "./components/CustomDashletChart/customDashletMixChart";

const ResponsiveReactGridLayout = WidthProvider(Responsive);


export default function DefaultDashboard({ data, addedDashlet, setAddedDashlet, setOpenAddDashlet, updatedLayout, setUpdatedLayout, addDashlet, isUpdateLayout, setValue, value,setStartJourney }) {
    const currentTheme = useTheme();

    // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });
    const [currentTab, setCurrentTab] = useState(data.current_tab);
    const [currentDashlets, setCurrentDashlets] = useState(data.dashlets);
    const { removeDashletLoading } = useSelector((state) => state.dashboard);

    const [menuData, setMenuData] = useState(null);
    const [menuNumber, setMenuNumber] = useState(null);

    const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    const [compactType, setCompactType] = useState("vertical");
    const [mounted, setMounted] = useState(false);
    const [layouts, setLayouts] = useState({ lg: generateLayout(data.dashlets || []) });
    const {dashboardData} = useSelector((state) => state.dashboard);
    const [allTabFilter,setAllTabFilter] = useState(pathOr([], [value, "allTabFilter"], dashboardData));


    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const { isAuthenticated } = useSelector((state) => state.auth);
    const [openEditDialog, setOpenEditDialog] = useState(false);

    const [configuredDashlet, setConfiguredDashlet] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
    const [layoutIsChanged, setLayoutIsChanged] = useState(true);
    const [filterToBeChange, setFilterToBeChange] = useState([]);
    const [isDashletUpdated, setIsDashletUpdated] = useState([]);
    const [showXirrVersion, setShowXirrVersion] = useState('overall');
    const currentUserData = useSelector((state) => state.config.currentUserData);
    const user_name = pathOr('', ['data', 'attributes', 'user_name'], currentUserData);
    const user_id = pathOr('', ['data', 'attributes', 'id'], currentUserData);
    const currentUserAttributes = pathOr('', ['data', 'attributes'], currentUserData);
    const handleRemoveDialogOpen = () => {
        setAnchorEl(null);
        setRemoveDialogOpen(true);
    };

    const onChange = (field, val, data) => {
        // setCurrency(field.options[event.target.value]);
// console.log("onchange",field,val,data)
        field['value'] = field['type']==='relate'?{id:val['id'],value:val['value']}:val['id']?val['id']:val;
        setIsDashletUpdated(pathOr([],['shouldUpdate'],data));
        const updateFieldIndex = data.data.findIndex((element) => {
            return element.name === field.name;
        });
        if (!data['isSubmit']) {
            data['data'][updateFieldIndex] = field;
            // console.log("filter onchange", field, val, data)
            const params = {
                "configureDashlet": {
                    "id": pathOr("", ['id'], data),
                    "module": "HomeApp",
                    "configure": "true",
                    'type': pathOr("dafault", ['type'], data),
                    'data': data,
                    'currentTab': currentTab,
                    'dashlets': currentDashlets
                }

            };
            try {
                dispatch(configureDashlet(params)).then(function (res) {
                    if (res?.data?.status === 200) {
                        // console.log("resdddddddddddddata",res.data.allTabFilter)
                        setAllTabFilter(pathOr(allTabFilter,['data','allTabFilter'],res))
                        // console.log("allTabFilter",allTabFilter)
                        //   toast('Dashlet Configured Successfully!');

                        //   if(pathOr(false,['isLoadComplete'],data)){
                        //     console.log('pppppppppppppppppppparams',params,data)
                        //     dispatch(getCurrentTab(value, 'this_year')).then((res)=>{
                        //        toast('Dashboard Updated Successfully!')
                        //      })
                        //   }else{
                            setIsDashletUpdated([]);
                        setConfiguredDashlet(res.data);
                        toast('Dashlet Updated Successfully!')
                        //   }

                    } else {
                        toast('Something went wrong!');

                    }
                });
            } catch (e) {
                toast('Something went wrong!');

            }
        } else {
            data['data'][updateFieldIndex] = field;
            setFilterToBeChange({ ...filterToBeChange, [pathOr("", ['id'], data)]: data })
        }


    };

    const isSubmitFilter = (id) => {
        const params = {
            "configureDashlet": {
                "id": id,
                "module": "HomeApp",
                "configure": "true",
                'type': 'custom',
                'data': filterToBeChange[id],
                'currentTab': currentTab,
                'dashlets': currentDashlets
            }

        };
        // console.log("isSubmitFilter",filterToBeChange)
        try {
            dispatch(configureDashlet(params)).then(function (res) {
                if (res?.data?.status === 200) {
                    // console.log("configuredDashlet",configuredDashlet,res.data)
                    // toast('Dashlet Configured Successfully!');
                    setConfiguredDashlet(res.data);
                    // dispatch(getCurrentTab(value, 'this_year')).then((res) => {
                        
                        toast('Dashlet Updated Successfully!')
                    // })
                } else {
                    toast('Something went wrong!');

                }
            });
        } catch (e) {
            toast('Something went wrong!');

        }
    }

    const handleRemoveDialogClose = () => {
        setAnchorEl(null);
        setRemoveDialogOpen(false);
    };
    const handleClickOpenEditDialog = () => {
        setAnchorEl(null);
        setOpenEditDialog(true);
    };
    useEffect(() => {
        if (addedDashlet) {
            layouts.lg.unshift(addedDashlet)
            setLayouts({ lg: generateLayout([]) });
            setLayouts({ lg: generateLayout(layouts.lg) });
            setLayoutIsChanged(true);
            setAddedDashlet(false)

        }
    }, [addedDashlet]);

    useEffect(() => {
        if (configuredDashlet) {


            let isCstmDashlet = pathOr([], ['dashlets'], configuredDashlet);

       if (isCstmDashlet) {
                if(typeof isCstmDashlet === 'object'){
                   isCstmDashlet = Object.values(isCstmDashlet);
                }
                
                isCstmDashlet && isCstmDashlet.map((das, found) => {
                    if(pathOr(false, ['position', 'data', 'sameResponseTo'], das)){
                        return;
                    }
                  
                    // const found = layouts.lg.findIndex(element => element.data.id === das);
                    layouts.lg[found] = das;
                    // layouts.lg[found]['i'] = found.toString();


                    setLayouts({ lg: generateLayout([]) });
                    setLayouts({ lg: generateLayout(layouts.lg) });
                    setAllTabFilter(pathOr(allTabFilter, ['allTabFilter'], configuredDashlet))
                    setConfiguredDashlet(false)
                })


            } else {
               
                configuredDashlet['module'] = pathOr(menuData.data.module, ['data', 'meta', 'dashlet_module'], menuData);
                layouts.lg[menuNumber]['data'] = configuredDashlet;
                setLayouts({ lg: generateLayout([]) });
                setLayouts({ lg: generateLayout(layouts.lg) });
                setConfiguredDashlet(false)
            }





        }
    }, [configuredDashlet]);

    useEffect(() => {

        setLayoutIsChanged(true)
    }, [updatedLayout, addedDashlet])

    if (!isAuthenticated) {
        history.push("/");
        return;
    }

    const deleteDashlet = () => {
        // console.log("dashlet",menuData);
        let dashlet = menuData;
        let dashletNumber = menuNumber;
        let params = {
            "category": "module",
            "dashlet_module": "HomeApp",
            "current_tab": currentTab,
            "dashlet_id": dashlet.data.id,
        };

        try {
            dispatch(removeDashlet(params)).then(function (res) {
                if (res.ok) {
                    layouts.lg.splice(dashletNumber, 1);

                    setLayouts({ lg: generateLayout([]) });
                    setLayouts({ lg: generateLayout(layouts.lg) });
                    setLayoutIsChanged(true);
                    toast('Dashlet Removed Successfully!');
                    setAnchorEl(null);
                    setRemoveDialogOpen(false);

                } else {
                    toast('Something went wrong!');
                }
            });
        } catch (e) {
            toast('Something went wrong!');
        }
    }


    const handleClick = (e, l, i) => {
        setAnchorEl(e.currentTarget);
        setMenuData(l);
        setMenuNumber(i);

    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuData(null);
        setMenuNumber(null);

    };
    const dashletActions = (i) => {
        return <Menu
            key={"dashletActions" + i}
            id={"dashletActions" + i}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            keepMounted
            className={classes.dashletActions}
        >
            <MenuItem className={classes.selectFontDash} onClick={() => handleClickOpenEditDialog()}>Edit</MenuItem>
            {/* <MenuItem onClick={() => refreshDashlet()}>Refresh</MenuItem> */}
            <MenuItem className={classes.selectFontDash} onClick={handleRemoveDialogOpen}>Remove</MenuItem>
        </Menu >
    }
    const renderReportData = (reportData, i) => {
        // console.log("reportData-DefaultDashboard")
        // console.log("reportData = ",reportData)
        let rDataGroup = pathOr([], ['data', 'report_data', 'group_outer_block'], reportData);
        let rOnlyCharts = pathOr([], ['data', 'onlyCharts'], reportData);
        let rDataNotGroup = pathOr([], ['data', 'report_data', 'group_outer_block', 'group_data'], reportData);
        let isGroup = parseInt(pathOr(false, ['data', 'report_data', 'is_group_data'], reportData));
        let dashlet_id = pathOr([], ['data', 'dashlet_id'], reportData);

        let rChart = pathOr([], ['data', 'report_chart', 'chart'], reportData);
        let isdata = pathOr([], ['data'], reportData);
        // console.log("isdata = ",isdata);
        // console.log("isdata length = ",isdata.length);
        if (isdata.length !== 0) {
            return (<>
                {rChart.map((chartData, key) => (
                    <Paper elevation={3} className={classes.chartBox} key={chartData.id}>
                        <AORCharts
                            key={chartData.id}
                            chartId={chartData.id}
                            chartType={chartData.type}
                            dataJson={chartData}
                            height="400px"
                            width="100%"
                            layoutIsChanged={layoutIsChanged}
                            setLayoutIsChanged={setLayoutIsChanged}
                            view="Dashlet"
                        />
                    </Paper>
                ))}
                {!rOnlyCharts ?
                    isGroup ? rDataGroup.map((item, n) => {
                        return <div key={"reportTable-" + i + "-" + n} className={classes.dashletList}><DashletList module={item.group_data.module} tableData={item.group_data} currentTab={currentTab} titleKey={item.display_value} title={item.display_label || ''} dashlet_id={dashlet_id} setValue={setValue} /></div>
                    }) : reportData.data ? <div key={"reportTable-" + i} className={classes.dashletList}><DashletList module={rDataNotGroup.module} tableData={rDataNotGroup} currentTab={currentTab} setValue={setValue} dashlet_id={dashlet_id} /></div> : null : null}

            </>
            )
        }
        else {
            return (<>
                <NoRecord
                    view='dashlet_report'
                    subpanel_module=''
                    module=''
                />
            </>
            )
        }
    }
    const renderIframeData = (iframeData) => {
        let rssOutputUrl = iframeData.data.rss_output || ''
        let height = iframeData.data.height || ''

        //  <iframe src={rssOutputUrl} height="100%" width="100%"  ></iframe>;
        return <Iframe url={rssOutputUrl}
            height="100%"
            width="100%"
            id={iframeData.id}
            // className="myClassname"
            display="initial"
            position="relative" />

    }
    const showDashletType = (l, i, type) => {
        switch (type) {
        case 'Filter':
            return <CustomDashletFilter key={i} data={l.data} onChange={onChange} isSubmitFilter={isSubmitFilter} />;
        case 'Form':
            return <CustomDashletForm key={i} data={l.data}  allTabFilter={allTabFilter} currentUserAttributes={currentUserAttributes}/>;
        case 'Policy List':
                return <CustomDashletList key={i} data={l.data} value={value} setValue={setValue} allTabFilter={allTabFilter} isDashletUpdated={isDashletUpdated}/>;
        case 'Card':
                 return <CustomCardList key={i} data={l.data} value={value} setValue={setValue} allTabFilter={allTabFilter} setAllTabFilter={setAllTabFilter} isDashletUpdated={isDashletUpdated}/>;
    
        case 'Table List':
                let newTableData = pathOr([], ['result', 'data'], l.data);
                let isAPI = pathOr(false, ['data', 'data', 'isAPI'], l.data);
                let isAccordionTable = pathOr(false, ['data', 'data', 'isAccordionTable'], l.data);
            
                if(isAPI || isAccordionTable){
                    return <CustomTableList key={i} data={l.data} setValue={setValue} setShowXirrVersion={setShowXirrVersion} showXirrVersion={showXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter} />;

                }else{
                    return <DashletList key={"DashletList-" + i} setIsDashletUpdated={setIsDashletUpdated} module={l.data && l.data.module ? l.data.module : ''} tableData={newTableData} fullData={l.data} currentTab={currentTab} dashlet_id={l.data.id} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter} setConfiguredDashlet={setConfiguredDashlet} setValue={setValue}/>;

                }
                case 'Custom Reports':
               
                return <CustomTableList key={i} data={l.data} setValue={setValue} setShowXirrVersion={setShowXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;
            case 'Chart':
              
                if(pathOr('', ['data','type'], l.data)==='xirr' || pathOr('', ['data','type'], l.data)==='policy_summary'){
                    return <CustomDashletChartXirr key={i} data={pathOr([], ['data'], l.data)} fullData={pathOr([], ['data'], l)} value={value} showXirrVersion={showXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;

                }else if(pathOr('', ['data','type'], l.data)==='xirr_group'){
                    return <CustomDashletGroupChartXirr key={i} data={pathOr([], ['data'], l.data)} fullData={pathOr([], ['data'], l)} value={value} showXirrVersion={showXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;
                }else if(pathOr('', ['data','charts',0,'type'], l.data)==='mix_chart'){
                    return <CustomDashletMixChart key={i} data={pathOr([], ['data','charts',0], l.data)} fullData={pathOr([], ['data'], l)} value={value} showXirrVersion={showXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;
                }else{
                    return <CustomDashletChart key={i} data={pathOr([], ['data'], l.data)} result={pathOr([], ['data','result'], l)} fullData={pathOr([], ['data'], l)} value={value} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;

                }
                         case 'Compare':
                return <CustomDashletCompare key={i} data={l.data} fullData={pathOr([], ['data'], l)} />;
            case 'Progress Bar':
                return <ProgressBar key={i} data={l.data} allTabFilter={allTabFilter} />;
            case 'Button':   
                return <CustomTableList key={i} data={l.data} setValue={setValue} setShowXirrVersion={setShowXirrVersion} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter}/>;
            default:
                return <div key={i} >

                    {l.data ?
                        l.data.module === 'AOR_Reports' ?
                            renderReportData(l.data, i)
                            : l.data.module === 'Home' ? renderIframeData(l.data) :

                                <DashletList key={"DashletList-" + i} setIsDashletUpdated={setIsDashletUpdated} module={l.data && l.data.module ? l.data.module : ''} tableData={pathOr([], ['data'], l.data)} currentTab={currentTab} dashlet_id={l.data.id} isDashletUpdated={isDashletUpdated} allTabFilter={allTabFilter} setConfiguredDashlet={setConfiguredDashlet} setValue={setValue}/>
                        : null}
                </div>;
                break;
        }
    }
    const makeid=()=> {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      
        for (var i = 0; i < 5; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
      
        return text;
      }
    const generateDOM = () => {
        return layouts.lg && layouts.lg.map((l, i) => {
            let dashletSubType = pathOr(null, ['subType'], l.data);

            let isHeader = pathOr(false, ['isHeader'], l.data);
            // console.log("dashletSubTypedashletSubTypedashletSubType", l,i)
            
            return pathOr(true, ['isHiddenCheckField',1], l.data)===pathOr(true, [pathOr('', ['isHiddenCheckField',0], l.data)], currentUserAttributes) || isUpdateLayout?isHeader || isUpdateLayout ? <Card key={i}>
                <CardHeader
                    key={makeid()}
                    avatar={
                        // <FaIcon
                        //     icon={pathOr("fas fas fa-cube ", ['meta', 'dashlet_icon'], l.data)}
                        //     size="1x"
                        // />
                        " "
                    }
                    action={
                        <>  
                            {process.env.REACT_APP_CRM_USERNAME === user_name || process.env.REACT_APP_CRM_USERNAME === user_id ?
                             <IconButton
                                aria-label={"settings"}
                                aria-controls={"dashletActions"}
                                aria-haspopup="true"
                                key={makeid()}
                                onClick={(e) => {
                                    handleClick(e, l, i)
                                }}
                            >
                                <MoreVert style={{ color: '#FFFFFF' }} key={makeid()}/>
                            </IconButton> 
                            : <div className={classes.IconCss} key={makeid()}></div>}
                            
                        </>
                    }
                    title={pathOr(pathOr("", ['label'], l.data), ['meta', 'dashlet_title'], l.data)}
                    // subheader="September 14, 2016"
                    className={classes.dashletHeader}
                />
                <CardContent key={i} className={classes.dashletContentRoot}>
                    {showDashletType(l, i, dashletSubType)}
                </CardContent>
            </Card> 
            : <div key={i} style={{ padding: '2px 0px' }}>
                {showDashletType(l, i, dashletSubType)}
                </div>:<span key={i}></span>;
        });
    }

    const onBreakpointChange = (breakpoint) => {
        setCurrentBreakpoint(breakpoint);

    }


    const onLayoutChange = (layout, oldItem, newItem,
        placeholder, e, element) => {

        if (oldItem !== newItem) {
            let newLayout = layout.map((item, n) => {
                return {
                    ...item,
                    data: layouts.lg[n].data
                };

            });
            newLayout = generateLayout(newLayout);
            let params = {
                "current_tab": currentTab.toString(),
                "layout": newLayout,
            };
            setUpdatedLayout(params);
            setLayouts({ lg: generateLayout(newLayout) });



        }
    }

    const onNewLayout = () => {

        // setLayouts({ lg: layoutJson });

    }
    return (
        <div style={{ padding: '12px', marginBottom: '200px' }}>
         
            <MuiThemeProvider theme={getMuiTheme(currentTheme)}>

                {layouts.lg.length ?
                    isUpdateLayout ?
                        <ResponsiveReactGridLayout
                            // {...this.props}
                            key={currentTab}
                            className="layout"
                            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                            // cols={{ lg: 8, md: 8, sm: 6, xs: 4, xxs: 2 }}
                            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                            layouts={layouts}
                            onBreakpointChange={onBreakpointChange}
                            // onLayoutChange={onLayoutChangeUpdateCharts}
                            onDragStop={onLayoutChange}
                            onResizeStop={onLayoutChange}

                            // WidthProvider option
                            measureBeforeMount={false}
                            // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
                            // and set `measureBeforeMount={true}`.
                            useCSSTransforms={mounted}
                            compactType={compactType}
                            preventCollision={!compactType}
                            // rowWidth={200}
                            // rowHeight={200}
                            // width={1200}
                            margin={[5, 10]}

                        >

                            {generateDOM()}

                        </ResponsiveReactGridLayout>
                        :
                         generateDOM()
                          :
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item sm={6} xs={12}>
                            {/* <Card className={classes.noDashletsRoot}>
                                <img className={classes.img} alt="complex" src={dashboardImg} />
                                <CardActions>
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Button variant="outlined" color="primary"

                                            aria-label={"add-dashlet"}
                                            aria-controls={"add-dashlet"}
                                            aria-haspopup="true"
                                            onClick={(e) => {
                                                setOpenAddDashlet(true)
                                            }}
                                        >
                                            <Icon className="fa fa-plus-circle" color="primary" />
                                            &nbsp;Add Dashlet
                                        </Button>
                                    </Grid>

                                </CardActions>
                            </Card> */}
                            <Card>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Welcome
        </Typography>
        <Typography variant="body2" color="text.secondary">
        On behalf of Axa, I would like to officially welcome you in our business. We value your support and contribution to our business, and we trust that your experience with our business will bring you the utmost satisfaction.

        </Typography>
      </CardContent>
      <CardActions>
        <Link href="#" underline="none" onClick={()=>setStartJourney(true)}>Let's Start</Link>
      </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                }
                {openEditDialog ? <EditDashlet data={menuData} key="editDashletDialog" openEditDialog={openEditDialog} setOpenEditDialog={setOpenEditDialog} setConfiguredDashlet={setConfiguredDashlet} configuredDashlet={configuredDashlet} addDashlet={addDashlet} value={value} /> : null}

                {dashletActions()}
                <Dialog
                    open={removeDialogOpen}
                    onClose={handleRemoveDialogClose}
                    aria-labelledby="alert-remove-dialog-title"
                    aria-describedby="alert-remove-dialog-description"
                >
                    <DialogTitle id="alert-remove-dialog-title">{"Remove Dashlet"}

                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-remove-dialog-description">
                            Are you sure you want to remove this Dashlet?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleRemoveDialogClose} color="primary" size="small" variant="contained" style={{ color: "White" }}>
                            Cancel
                        </Button>

                        {
                            removeDashletLoading ?
                                <Button color="primary" size="small" variant="contained" autoFocus style={{ color: "White" }}>Removing
                                    <CircularProgress size={14} style={{ marginLeft: 10, color: "White" }} /> </Button>
                                :
                                <Button onClick={() => deleteDashlet()} color="primary" size="small" variant="contained" autoFocus style={{ color: "White" }}>Ok</Button>
                        }
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

const generateLayout = (layoutData) => {
    // let x = 1;
    return layoutData && layoutData.map((item, n) => {
        // console.log("iiiiiiiiiiiiiiiiitem",item)
        item.data.id = item.i;
        // if (x >= 3) {
        //     x = 0;
        // }
        // let m = x * 2;
        // x++;

        return {
            x: parseInt(item.x) || 0,//m,
            y: parseInt(item.y) || 0,
            w: 12,// item.w === 'Infinity' ? Infinity : parseInt(item.w) || 4,
            h: 2,//parseInt(item.h) || 3,
            i: n.toString(),//item.i,
            data: item.data || [],
            // minW: 2,
            // minH: 2,
            // maxH: 4,
            static: item.static || false,
            moved: item.moved || false
        };

    });
}


